export class ListZeroEtlJobSyncsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ZeroEtlJobSyncsFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlJobSyncsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
